import Filters from 'components/Catalog/Filters/Filters';

export default Filters;
